<template>
  <div>
    <div class="container-md">
      <div class="container-bg p-5">
        <div class="row">
          <div class="col-12">
            <h3 class="text-uppercase">Commissies</h3>
          </div>
          <!--
                        Get committees user
                     -->
          <div class="col-12 mt-3">
            <table class="table table-striped table-responsive-sm">
              <thead>
                <tr>
                  <th style="min-width: 200px;">Commissie</th>
                  <th style="min-width: 200px;">Rol</th>
                  <th>Van</th>
                  <th>Tot</th>
                  <th></th>
                </tr>
                <tr
                  v-if="
                    committees &&
                      userHasPermissions([
                        'Beheer Commissies',
                        'Ledenadministratie',
                      ])
                  "
                >
                  <th>
                    <select2
                      @select="pickCommittee($event, 'create')"
                      :options="
                        committees.map((d) => {
                          return { id: d.id, text: d.title };
                        })
                      "
                      :settings="{}"
                      v-model="item.committee_id"
                    >
                    </select2>
                  </th>
                  <th>
                    <select2
                      @select="pickRole($event, 'create')"
                      :options="
                        committeesRole.map((d) => {
                          return { id: d.id, text: d.title };
                        })
                      "
                      :settings="{}"
                      v-model="item.committeerole_id"
                    >
                    </select2>
                  </th>
                  <th>
                    <input
                      class="form-control"
                      type="date"
                      name="date_from"
                      v-model="item.from"
                    />
                  </th>
                  <th>
                    <input
                      class="form-control"
                      type="date"
                      name="date_end"
                      v-model="item.to"
                    />
                  </th>
                  <th>
                    <button
                      class="btn btn-dark text-white mt-3 mr-2"
                      v-on:click="saveCommittee"
                      v-if="!saving"
                    >
                      Opslaan
                    </button>
                  </th>
                </tr>
              </thead>
              <tbody v-if="user.committees_instances">
                <tr
                  v-for="(committee, index) in user.committees_instances"
                  :key="'user_' + user.id + 'committee_' + index"
                >
                  <td v-if="index == editItem">
                    <select2
                      v-model="committee.pivot.committee_id"
                      @select="pickCommittee($event, 'edit')"
                      :options="
                        committees.map((d) => {
                          return { id: d.id, text: d.title };
                        })
                      "
                      :settings="{ width: '100px' }"
                    >
                    </select2>
                  </td>
                  <td v-else>
                    {{ committee.title }}
                  </td>
                  <td v-if="index == editItem">
                    <select2
                      v-model="committee.pivot.committeerole_id"
                      @select="pickRole($event, 'edit')"
                      :options="
                        committeesRole.map((d) => {
                          return { id: d.id, text: d.title };
                        })
                      "
                      :settings="{ width: '100px' }"
                    >
                    </select2>
                  </td>
                  <td v-else>
                    <span v-if="committee.role">{{
                      committee.role.title
                    }}</span>
                  </td>
                  <td v-if="index == editItem">
                    <input
                      class="form-control"
                      type="date"
                      name="date_from"
                      v-model="committee.pivot.date_start"
                    />
                  </td>
                  <td v-else>
                    {{ formatDate(committee.pivot.date_start) }}
                  </td>
                  <td v-if="index == editItem">
                    <input
                      class="form-control"
                      type="date"
                      name="date_end"
                      v-model="committee.pivot.date_end"
                    />
                  </td>
                  <td v-else>
                    {{ formatDate(committee.pivot.date_end) }}
                  </td>
                  <td v-if="index == editItem">
                    <button
                      v-if="
                        userHasPermissions([
                          'Beheer Commissies',
                          'Ledenadministratie',
                        ])
                      "
                      class="btn btn-dark text-white mt-3 mr-2"
                      v-on:click="saveEdit(user.id, committee)"
                    >
                      Opslaan
                    </button>
                  </td>
                  <td v-else>
                    <div
                      v-if="
                        userHasPermissions([
                          'Beheer Commissies',
                          'Ledenadministratie',
                        ])
                      "
                    >
                      <a
                        href="javascript:void(0)"
                        class="mt-3 mr-2"
                        v-on:click="isEdit(index)"
                        ><i class="fas fa-edit"></i
                      ></a>
                      <a
                        href="javascript:void(0)"
                        class="mt-3 mr-2"
                        v-on:click="deleteCommittee(committee.pivot.id)"
                        ><i class="fas fa-trash"></i
                      ></a>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import mixins from "../../../mixins/index";
export default {
  name: "committees",
  mixins: [mixins],
  data() {
    return {
      saving : false,
      committees: [],
      committeesRole: [],
      user: {},
      selected_committees: [],
      edit: true,
      item: {
        user_id: 0,
        selected_role: [],
        selected_committee: [],
        from: "",
        to: "",
      },
      editItem: -1,
      editobj: {
        selected_role: null,
        selected_committee: null,
        from: null,
        to: null,
      },
    };
  },
  methods: {
    deleteCommittee(id) {
      if (!window.confirm("Are you sure you want delete this item?")) {
        return false;
      }

      this.$store
        .dispatch("delete", "api/v1/users/remove/committee/"+this.$route.params.id+ "/" + id)
        .then((data) => {
          console.log(data);
          window.location.reload();
        })
        .catch((error) => {
          console.log(error.request);
        });
    },
    pickCommittee(obj, type) {
      var tmp;
      if (type == "create") {
        tmp = this.committees.filter(function(user) {
          return user.id == obj.id;
        });
        console.log(obj);
        this.item.selected_committee[0] = tmp[0];
        //this.updateTo();
      } else {
        tmp = this.committees.filter(function(user) {
          return user.id == obj.id;
        });
        console.log(obj);
        this.editobj.selected_committee[0] = tmp[0];
      }
    },
    pickRole(obj, type) {
      var tmp;
      if (type == "create") {
        console.log(type);

        tmp = this.committeesRole.filter(function(user) {
          return user.id == obj.id;
        });
        console.log(obj);
        this.item.selected_role[0] = tmp[0];
        //this.updateTo();
      } else {
        tmp = this.committeesRole.filter(function(user) {
          return user.id == obj.id;
        });
        console.log(obj);
        this.editobj.selected_role[0] = tmp[0];
      }
    },
    saveCommittee() {
      this.saving = true;
      if (
        !this.item.from ||
        this.item.selected_committee.length == 0 ||
        this.item.selected_role.length == 0
      ) {
        return false;
      }
      this.item.user_id = this.user.id;
      this.$store
        .dispatch("post", {
          endpoint: "api/v1/committee/role/user",
          details: this.item,
        })
        .then((response) => {
          console.log(response);
          window.location.href =
            "/profile/" + this.$route.params.id + "/committees";
        })
        .catch((error) => {
          if (error.request.status == 422) {
            var response = JSON.parse(error.request.response).errors;
            for (var err in response) {
              this.error = response[err][0];
            }
          }
        });
    },
    isEdit: function(index) {
      this.editItem = index;
      var getObj = this.user.committees[index];
      this.editobj.from = getObj.pivot.date_start;
      this.editobj.to = getObj.pivot.date_end;
      this.editobj.selected_committee = getObj.pivot.committee_id;
      this.editobj.selected_role = getObj.pivot.committee_id;
    },
    saveEdit(user_id, committee) {
      var getObj = committee;
      this.editobj.from = getObj.pivot.date_start;
      this.editobj.to = getObj.pivot.date_end;
      this.editobj.selected_committee = getObj.pivot.committee_id;
      this.editobj.selected_role = getObj.pivot.committeerole_id;
      this.editobj.id = getObj.pivot.id;

      if (
        !this.editobj.from ||
        !this.editobj.selected_committee ||
        !this.editobj.selected_role
      ) {
        return false;
      }

      this.$store
        .dispatch("put", {
          endpoint:
            "api/v1/committee/role/user/" + user_id + "/" + committee.id,
          details: this.editobj,
        })
        .then((response) => {
          console.log(response);
          window.location.href =
            "/profile/" + this.$route.params.id + "/committees";
        })
        .catch((error) => {
          if (error.request.status == 422) {
            var response = JSON.parse(error.request.response).errors;
            for (var err in response) {
              this.error = response[err][0];
            }
          }
        });
    },
  },
  mounted() {
    this.$store
      .dispatch(
        "get",
        "api/v1/committees/all/no-user/parent-id/3" // + this.$route.params.id
      )
      .then((data) => {
        this.committees = data.data.data;
      })
      .catch((error) => {
        console.log(error);
      });

    this.$store
      .dispatch("get", "api/v1/committeeroles/parent_id/3")
      .then((data) => {
        console.log(data.data.data);
        this.committeesRole = data.data.data;
      })
      .catch((error) => {
        console.log(error);
      });

    if (this.$route.params.id) {
      this.$store
        .dispatch("get", "api/v1/users/" + this.$route.params.id)
        .then((data) => {
          this.user = { ...data.data.data };
          this.user.committees_instances = this.user.committees_instances.map(
            (d) => {
              if (d.pivot.date_start != null) {
                d.pivot.date_start = this.cleanDate(d.pivot.date_start);
                d.pivot.date_end = this.cleanDate(d.pivot.date_end);
              }
              return d;
            }
          );

          this.selected_committees = this.user.committees_instances.map(
            (d) => d.id
          );
        })
        .catch((error) => {
          console.log(error);
        });
    }
  },
  created() {
    this.$store.dispatch("get", "api/v1/today").then((data) => {
      this.item.from = data.data.today;
    });
  },
  computed: {
    committeesList() {
      var list = [];
      if (this.committees.length > 0) {
        this.committees.forEach(function(item) {
          console.log(item.id, item.title);
          let title;
          if (item.parent_id == 0) {
            return true;
          } else if (item.parent_id > 0) {
            title = item.parent.title + " - " + item.title;
          } else {
            title = item.title;
          }
          if (title.length > 0) {
            list.push({ id: item.id, title: title });
          }
        });
      }

      return list;
    },
  },
};
</script>

<style scoped>
.nested-list {
  color: #6c6c6c;
  opacity: 1;
}

.card {
  background: #4192d9 0% 0% no-repeat padding-box;
  box-shadow: 1px 5px 10px #0000004b;
  border-radius: 20px;
  padding: 0;
}

.no-gutters {
  background: #4192d9 0% 0% no-repeat padding-box;
  box-shadow: 1px 5px 10px #0000004b;
  border-radius: 20px;
}

.card-footer {
  border-top: unset;
}

@media (min-width: 576px) {
  .modal-dialog {
    max-width: 900px;
    margin: 1.75rem auto;
    margin-top: 9rem;
  }
}
.form-control {
  background: #ffffff 0% 0% no-repeat padding-box;
  box-shadow: 1px 5px 10px #00000029;
  border-radius: 4px;
  opacity: 1;
  border: 1px #ced4da;
}

.dropdown-item {
  border-bottom: 1px solid;
}

.dropdown-menu {
  border: 1px solid;
  padding: 0;
}
</style>
